module.exports = __webpack_public_path__ + "static/media/rehearsal_dinner@2x.562cfd56.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/icons/rehearsal_dinner@2x.png
 ** module id = 2244
 ** module chunks = 50
 **/